import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = (isWideMenu) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      linkWrapper: {
        zIndex: isWideMenu ? 1 : 2,
        position: 'relative',
        display: 'flex',
        '&.hasSubItems': {
          flexDirection: 'column',
          justifyContent: 'center',
        },
        '&.home-link': {
          display: 'none',
        },
        [theme.breakpoints.up('xl')]: {
          marginLeft: MIDDLE_MARGIN,
          padding: '16px 0',
          '&.home-link': {
            display: 'flex',
          },
          '&:first-child': {
            marginLeft: 0,
          },
          '&.hasSubItems': {
            '&:hover $linkIcon': {
              [theme.breakpoints.up('md')]: {
                transform: 'rotate(0)',
              },
            },
            '&:hover $sublistList': {
              opacity: 1,
              top: 0,
              padding: '82px 0 0',
              height: 'auto',
            },
          },
        },
      },
      linkWrap: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.up('xl')]: {
          justifyContent: 'flex-start',
          width: 'auto',
        },
      },
      link: {
        textDecoration: 'none',
        fontSize: 18,
        fontWeight: 'bold',
        color: colorsPalette.white,
        display: 'block',
        transition: '0.3s',
        padding: '18px 0',
        marginLeft: 0,
        width: '100%',
        '&:first-letter': {
          textTransform: 'capitalize',
        },
        [theme.breakpoints.up('xl')]: {
          fontSize: 16,
          padding: 0,
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          color: 'inherit',
          textDecoration: 'none',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          position: 'relative',
          '&.withSubItems': {
            zIndex: 10,
          },
          '&:not(.withSubItems):after': {
            content: '""',
            position: 'absolute',
            top: '120%',
            height: 3,
            width: '0%',
            left: '1%',
            backgroundColor: theme.palette.primary.main,
            transition: '0.5s ease all .3s',
          },
          '&:after': {
            width: '99%',
            transition: '0.3s ease all',
          },
          '&:not(.withSubItems).active:after': {
            width: '99%',
          },
          [theme.breakpoints.between('sm', 'md')]: {
            fontSize: 16,
          },
        },
      },
      sublist: {
        margin: 0,
        width: '100%',
        transition: 'all 0.5s ease',
        display: 'flex',
        [theme.breakpoints.up('xl')]: {
          justifyContent: 'center',
          padding: `${MIDDLE_MARGIN}px 0 0`,
          borderTop: `1px solid ${fade(colorsPalette.white, 0.2)}`,
          background: fade(colorsPalette.blueDark, 0.85),
        },
      },
      sublistList: {
        listStyleType: 'none',
        display: 'none',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        width: 591,
        transition: 'opacity .5s ease-in-out',
        margin: 0,
        position: 'relative',
        opacity: 1,
        padding: 0,
        '&.opened': {
          maxWidth: 600,
          display: 'flex',
          width: '100%',
        },
        [theme.breakpoints.up('xl')]: {
          display: 'flex',
          opacity: 0,
          height: 0,
          padding: 0,
          position: 'absolute',
          overflow: 'hidden',
          justifyContent: 'flex-start',
          ...(isWideMenu
            ? {
                left: -320,
                width: 900,
              }
            : {
                left: -20,
                width: 600,
              }),
        },
      },
      sublistItem: {
        width: 271,
        marginBottom: SMALL_MARGIN / 2,
        paddingRight: 0,
        transition: 'all .3s',
        borderRadius: 10,
        [theme.breakpoints.up('xl')]: {
          width: 291,
          padding: 0,
          marginRight: 9,
        },
        '&:hover': {
          backgroundColor: theme.palette.secondary.dark,
        },
      },
      sublistLink: {
        display: 'block',
        paddingBottom: SMALL_MARGIN,
        paddingRight: MIDDLE_MARGIN,
        [theme.breakpoints.up('xl')]: {
          padding: `${SMALL_MARGIN}px ${SMALL_MARGIN}px ${SMALL_MARGIN}px 20px`,
        },
      },
      sublistTitle: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
        color: colorsPalette.white,
        fontSize: 16,
        [theme.breakpoints.up('xl')]: {
          textTransform: 'uppercase',
        },
      },
      sublistDescription: {
        fontSize: 14,
        lineHeight: 1.5,
        color: colorsPalette.gray,
        paddingTop: 5,
      },
      linkIcon: {
        display: 'block',
        width: 16,
        height: 16,
        marginLeft: 6,
        transform: 'rotate(180deg)',
        transition: 'transform .3s',
        '&.opened': {
          transform: 'rotate(0)',
        },
        [theme.breakpoints.up('md')]: {
          width: 12,
          height: 12,
        },
      },
    });
  });

export default useStyles;
